import { Outlet, useLocation } from "react-router";
import Layout from "../../layout/main";
import StackKit from "@/shared/components/kit/stack";
import Validation from "../../components/credits/validation";
/**
 * CreditsPage
 *
 * کامپوننت مدیریت مسیرهای مرتبط با بخش اعتبارات مشتری.
 *
 * @remarks
 * - از `useLocation` برای تشخیص مسیر جاری استفاده می‌کند.
 * - اگر مسیر دقیق "/credits" باشد، کامپوننت `Validation` را نمایش می‌دهد.
 * - در غیر این صورت، `Outlet` برای نمایش مسیرهای فرزند رندر می‌شود.
 * - کل محتوا در `Layout` و با استفاده از `StackKit` برای مدیریت چینش عمودی و فاصله‌بندی قرار دارد.
 *
 * @returns JSX.Element
 * کامپوننتی که صفحه اصلی اعتبارات را مدیریت می‌کند و مسیرهای فرزند را بر اساس مسیر فعلی نمایش می‌دهد.
 */

const CreditsPage = () => {
  const location = useLocation();

  const isExactCreditsPage = location.pathname === "/credits";

  return (
    <Layout>
      <StackKit direction={"column"} sx={{ width: "100%", maxWidth: "1740px" }}>
        {isExactCreditsPage ? <Validation /> : <Outlet />}
      </StackKit>
    </Layout>
  );
};

export default CreditsPage;
